/*
Monotype Foundry Platform API
Version 1.0.0

Definition: AiConsentRequest

Properties:
  featureAgreementId: string (required)
*/

var AiConsentRequest = (function () {
  function validateAiConsentRequest (arg) {
    // Validate featureAgreementId
    if (!arg.featureAgreementId) {
      throw new Error('AiConsentRequest.featureAgreementId: Missing property')
    }
    if (arg.featureAgreementId && !(typeof arg.featureAgreementId === 'string')) {
      throw new Error('AiConsentRequest.featureAgreementId: Wrong type: Got \'' + (typeof arg.featureAgreementId) + '\', but expected: \'string\'')
    }
  }
  function buildAiConsentRequest (arg) {
    var AiConsentRequest = arg
    // Complete featureAgreementId
    // Expected Type: string
    AiConsentRequest.featureAgreementId = AiConsentRequest.featureAgreementId || ''
    return AiConsentRequest
  }
  return {
    validate: validateAiConsentRequest,
    build: buildAiConsentRequest
  }
})()

module.exports = AiConsentRequest
